import React from 'react';

import { IMPROVEMENT_NOTE_MAPS } from '../../utils/teamPlanning';

import './MapFolderList.css';

export const VALORANT_MAPS = IMPROVEMENT_NOTE_MAPS;

export default function MapFolderList({ onSelect }) {
  return (
    <div className="map-folder-list">
      {VALORANT_MAPS.map((map) => (
        <div
          key={map}
          className="map-folder"
          onClick={() => onSelect(map, map)} // mapId, mapName
        >
          📁 {map}
        </div>
      ))}
    </div>
  );
}
